interface ProjectProgressBarProps {
  progresso: number;
  size?: "sm" | "md";
  showLabel?: boolean;
}

export default function ProjectProgressBar({ progresso, size = "md", showLabel = true }: ProjectProgressBarProps) {
  const barHeight = size === "sm" ? "h-1.5" : "h-2";
  const textSize = size === "sm" ? "text-xs" : "text-sm";

  let barColor = "bg-primary-500";
  if (progresso < 30) barColor = "bg-warning-500";
  else if (progresso >= 100) barColor = "bg-accent-500";

  return (
    <div className="flex items-center gap-2">
      <div className={`flex-1 ${barHeight} rounded-full bg-background-200 overflow-hidden`}>
        <div
          className={`${barHeight} rounded-full ${barColor} transition-all duration-300`}
          style={{ width: `${Math.min(progresso, 100)}%` }}
          role="progressbar"
          aria-valuenow={progresso}
          aria-valuemin={0}
          aria-valuemax={100}
          aria-label={`Progresso do projeto: ${progresso}%`}
        ></div>
      </div>
      {showLabel && (
        <span className={`${textSize} font-semibold text-foreground-700 w-10 text-right tabular-nums`}>
          {progresso}%
        </span>
      )}
    </div>
  );
}